const COLUMNS_HEADERS = {
  supplier: { sortable: true, searchable: true },
  name: { sortable: true, searchable: true },
  model: {
    translatable: true,
    sortable: true,
    filterable: true,
    filterableData: { 1: 'delivery', 2: 'laboratory' },
  },
  updatedAt: { isDate: true, translatable: true, sortable: true },
};

const BUTTONS = {
  editAction: { tooltip: 'editAction.template' },
  deleteAction: { tooltip: 'deleteAction.template' },
  copyAction: { tooltip: 'copyAction.template' },
};

export { COLUMNS_HEADERS, BUTTONS };
